import React, { useState, useEffect } from "react";
import { useStyles } from "../../../assets/jss/PraisoTable";
import clsx from "clsx";
import CustomBox from "../CustomBox/CustomBox";
import CustomTypography from "../CustomTypography/CustomTypography";
import moment from "moment";
import { getEndDate, getStartDate, getUserData, } from "../../../services/LocalStorageService";
import CustomPopover from "../CustomPopover/CustomPopover";
import CustomList from "../CustomList/CustomList";
import CustomListItem from "../CustomListItem/CustomListItem";
import CustomListItemText from "../CustomListItemText/CustomListItemText";
import {
    // CustomExpandLessIcon,
    CustomExpandMoreIcon,
} from "../CustomIcon/CustomIcon";
// import CustomListItemIcon from "../CustomListItemIcon/CustomListItemIcon";
import { PraisoTableTitleAction } from "./PraisoTableTitleAction";
import CustomIconButton from "../CustomIconButton/CustomIconButton";
import CustomDivider from "../CustomDivider/CustomDivider";
import { Trans, useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { Role, TableComponentCodes } from "../../../config/app-globals.enum";
import createIcon from "../../../assets/images/createIcon.png";
import exportIcon from "../../../assets/images/exportIcon.png";
import ErrorAlert from "../../ErrorAlert/ErrorAlert";


export default function PraisoTableViewSelector(props) {
    const { t } = useTranslation();
    const params = useParams();
    const history = useHistory();
    const classes = useStyles();
    const [startDate] = useState(getStartDate);
    const [endDate] = useState(getEndDate);
    // const tcId = props.tableSettingView === "wol" ? 1 : props.tableSettingView === "ce" ? 7 : props.tableSettingView === "seul" ? 8 : props.tableSettingView === "beul" ? 9 : props.tableSettingView === "ceul" ? 10 : props.tableSettingView === "deul" ? 11 : 0;
    const tcCode = props.tableSettingView;
    const [isViewChangeEnabled, setIsViewChangeEnabled] = useState(false);
    const [isViewActionEnabled, setIsViewActionEnabled] = useState(false);
    const [isExportEnabled, setIsExportEnabled] = useState(false);
    const [tableViewList, setTableViewList] = useState([]);
    const [selectedTableView, setSelectedTableView] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
        if (props.tableViewList && props.tableViewList.length) {
            const list = props.tableViewList.sort((a, b) => {
                const textA = a.tableName.toLowerCase();
                const textB = b.tableName.toLowerCase();

                return textA.localeCompare(textB);
            });
            list.unshift(list.splice(list.findIndex(item => item.isDefault), 1)[0])
            const userData = getUserData();
            if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
                var setValue = false; // = props.tableSettingView === "wol" ? true : false;
                /* if(props.tableSettingView === "wol" || props.tableSettingView === "ce" || props.tableSettingView === "seul" || props.tableSettingView === "beul" || props.tableSettingView === "ceul" || props.tableSettingView === "deul"){
                    setValue = true;
                } */
                if (props.tableSettingView) {
                    setValue = true;
                }
                setIsViewChangeEnabled(setValue);
                setIsViewActionEnabled(setValue);
                setIsExportEnabled(setValue);
                window.localStorage.setItem("tableView", JSON.stringify(list));
            }
            setTableViewList([...list]);
            setSelectedTableView(list.find((item) => item.isSelected));
        }
    }, [props.tableViewList]);

    const handleClick = (event) => {
        if (isViewChangeEnabled) {
            setAnchorEl(event.currentTarget);
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "praisoTitlePopover" : undefined;
    const changeTableView = (id) => {
        props.changeTableView(id);
        handleClose();
    };

    // useEffect(() => {
    //     if (props.tableColumns && props.tableColumns.length > 0) {
    //         const tableCols = [...props?.tableColumns||[]];
    //         const columns = tableCols.map(i =>{                
    //             return i?.Header?.props?.children||'';                           
    //         });
    //         setTableColumn(columns);
    //     }
    // }, [props]);

    function dateToLocaleString(date: string) {
        var d = new Date(date);
        return d.toDateString() + ' ' + d.toLocaleTimeString();
    }

    function filterDataforExport(tableData: any) {
        if (tableData.length > 0) {
            const filteredTableData = tableData.map(item => {
                if (item.registrationDate !== undefined && item.registrationDate !== null) {
                    item.registrationDate = dateToLocaleString(item.registrationDate);
                }
                if (item.userRoles && item.userRoles.length > 0) {
                    const role = item.userRoles.map(i => {
                        if (parseInt(i) === Role.DRIVER) {
                            i = String("DRIVER");
                        } else if (parseInt(i) === Role.ADMIN) {
                            i = String("ADMIN");
                        } else if (parseInt(i) === Role.GUEST) {
                            i = String("GUEST");
                        } else if (parseInt(i) === Role.SUPERADMIN) {
                            i = String("SUPERADMIN");
                        } else if (parseInt(i) === Role.SYSTEM) {
                            i = String("SYSTEM");
                        } else if (parseInt(i) === Role.USER) {
                            i = String("USER");
                        }
                        return i;
                    })
                    item.userRoles = role;
                }
                if (item.contentStatus !== undefined && item.eventTypeId !== null) {
                    if (item.contentStatus === 1) {
                        item.contentStatus = "ACTIVE"
                    } else if (item.contentStatus === 0) {
                        item.contentStatus = "ONHOLD"
                    } else if (item.contentStatus === -1) {
                        item.contentStatus = "NA"
                    }
                }
                if (item.isMobileLogin !== undefined && item.eventTypeId !== null) {
                    if (item.isMobileLogin) {
                        item.isMobileLogin = "Logged In"
                    } else {
                        item.isMobileLogin = "Not Logged In"
                    }
                }
                if (item.isWelcomeEmailSent !== undefined && item.eventTypeId !== null) {
                    if (item.isWelcomeEmailSent) {
                        item.isWelcomeEmailSent = "Sent"
                    } else {
                        item.isWelcomeEmailSent = "Not Sent"
                    }
                }
                if (item.severity !== undefined && item.eventTypeId !== null) {
                    if (item.severity === 0) {
                        item.severity = "NONE"
                    } else if (item.severity === 1) {
                        item.severity = "WARNING"
                    } else if (item.severity === 2) {
                        item.severity = "ALERT"
                    } else if (item.severity === 3) {
                        item.severity = "SEVER"
                    }
                }
                if (item.isSchoolRunSpeeding !== undefined && item.eventTypeId !== null) {
                    if (item.isSchoolRunSpeeding) {
                        item.isSchoolRunSpeeding = "School Run Speeding"
                    } else {
                        item.isSchoolRunSpeeding = "Not School Run Speeding"
                    }
                }
                if (item.isMotorwaySpeeding !== undefined && item.eventTypeId !== null) {
                    if (item.isMotorwaySpeeding) {
                        item.isMotorwaySpeeding = "Motorway Speeding"
                    } else {
                        item.isMotorwaySpeeding = "Not Motorway Speeding"
                    }
                }
                if (item.isDriverBan !== undefined && item.eventTypeId !== null) {
                    if (item.isDriverBan) {
                        item.isDriverBan = "Driving Ban"
                    } else {
                        item.isDriverBan = "No Driving Ban"
                    }
                }
                if (item.occurredAt) {
                    item.occurredAt = dateToLocaleString(item.occurredAt);
                }
                if (item.claimFrom) {
                    item.claimFrom = dateToLocaleString(item.claimFrom);
                }
                if (item.claimTo) {
                    item.claimTo = dateToLocaleString(item.claimTo);
                }
                if (item.eventTypeId !== undefined && item.eventTypeId !== null) {
                    if (item.eventTypeId === "21") {
                        item.eventTypeId = "Call Event"
                    } else if (item.eventTypeId === "22") {
                        item.eventTypeId = "Phone Usage Event"
                    } else if (item.eventTypeId === "23") {
                        item.eventTypeId = "Harsh Acceleration"
                    } else if (item.eventTypeId === "6") {
                        item.eventTypeId = "Harsh Braking"
                    } else if (item.eventTypeId === "7") {
                        item.eventTypeId = "Brake overuse"
                    } else if (item.eventTypeId === "8") {
                        item.eventTypeId = "Tailgating"
                    } else if (item.eventTypeId === "9") {
                        item.eventTypeId = "Excess Speed"
                    } else if (item.eventTypeId === "10") {
                        item.eventTypeId = "Poor Technique"
                    } else if (item.eventTypeId === "11") {
                        item.eventTypeId = "Fast Approach"
                    }
                }
                return item;
            })
            return filteredTableData;
        }
    }

    function filterColumnsforExport(columnData: any) {
        if (columnData.length > 0) {
            const filteredTableData = columnData.map(item => {
                if (item === 'occurredAt') {
                    item = 'Occurred At';
                } else if (item === 'userName' || item === 'name') {
                    item = 'Driver Name';
                } else if (item === 'fullName') {
                    item = 'Name';
                } else if (item === 'score') {
                    if (props.tableSettingView === TableComponentCodes.CONTENT_ENGAGEMENT)
                        item = 'Eng. Score';
                    else
                        item = 'Driver Score';
                } else if (item === 'rank') {
                    if (props.tableSettingView === TableComponentCodes.CONTENT_ENGAGEMENT)
                        item = 'Eng. Rank';
                    else
                        item = 'Praiso Rank';
                } else if (item === 'groupName') {
                    item = 'Group';
                } else if (item === 'speed') {
                    item = 'Speed';
                } else if (item === 'speedZone' || item === 'speedLimit') {
                    item = 'Speed Limit';
                } else if (item === 'severity') {
                    item = 'Severity';
                } else if (item === 'isSchoolRunSpeeding') {
                    item = 'School Run Speeding';
                } else if (item === 'isMotorWaySpeeding' || item === 'isMotorwaySpeeding') {
                    item = 'MotorWay Speeding';
                } else if (item === 'isDrivingBan' || item === 'isDriverBan') {
                    item = 'Driving Ban';
                } else if (item === 'activeContent') {
                    item = 'Content Active';
                } else if (item === 'sentContent') {
                    item = 'Content Sent';
                } else if (item === 'eventTypeId') {
                    if (props.tableSettingView === TableComponentCodes.MOBILE_DISTRACTION)
                        item = "Category";
                    else
                        item = 'Event';
                } else if (item === 'registrationDate') {
                    item = 'Created At';
                } else if (item === 'userRoles') {
                    item = 'Role';
                } else if (item === 'contentStatus') {
                    item = 'Content Status';
                } else if (item === 'isMobileLogin') {
                    item = 'Mobile App Status';
                } else if (item === 'isWelcomeEmailSent') {
                    item = 'Welcome Email';
                }

                return item;
            })
            return filteredTableData;
        }
    }

    const handleExportClick = () => {
        const statData = props.statData;
        let label = [];
        let stat = [];

        // Get the stats label and counts from Data
        if (statData !== undefined && statData !== null) {
            statData.map((wol) => {
                label.push(wol.label);
                stat.push(wol.statCount);
            });
        }

        let tableData = filterDataforExport(props.tableData);

        if (tableData && tableData.length > 0) {
            //Get the Selected column list data from tableData
            var filteredCols = selectedTableView.selectColumn.filter(function (k) {
                return (k !== "rankTrend" && k !== "scoreTrend" && k !== '');
            });

            const result = tableData.map(e => {
                let obj = [];
                filteredCols.forEach((k: string) => {
                    if (e[k] === undefined || e[k] === null)
                        obj.push('-')
                    else
                        obj.push(e[k]);
                })
                return obj;
            });

            filteredCols = filterColumnsforExport(filteredCols);
            let rows = [label, stat, [selectedTableView.tableName], filteredCols];
            result.map((r) => {
                rows.push(r);
            })

            const csvContent = "data:text/csv;charset=utf-8," + rows.map(e => e.join(",")).join("\n");

            if (navigator.msSaveBlob) { // IE 10+
                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                navigator.msSaveBlob(blob, selectedTableView.tableName);
            } else {
                const encodedUri = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", `${selectedTableView.tableName}.csv`);
                document.body.appendChild(link); // Required for FF
                link.click();
                document.body.removeChild(link);
            }
        }
    }

    const handleCustomView = () => {
        history.push(`/customtable/${tcCode}/create`);
    }

    // ----
    const [statusValue, setStatusValue] = React.useState(null);
    const [alertType, setAlertType] = React.useState("");
    const [alertMessage, setAlertMessage] = React.useState("");
    const [alertDescription, setAlertDescription] = React.useState("");
    const [isAlertOpen, setIsAlertOpen] = React.useState(false);
    const changeApiStatusCodeFunc = (status) => {
        setStatusValue(status.code);
        if (status.code === 0 || status.code === 200 || status.code === 201) {
            setAlertMessage(status.message ? status.message : t("SUCCESS"));
            setAlertType("success");
            setAlertDescription(t("TABLE_COMPONENT_HAS_BEEN_DELETED_SUCCESSFULLY"));
        } else {
            setAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setAlertType("error");
            setAlertDescription(t("FAILED_TO_DELETE_TABLE_COMPONENT"));
        }
        setIsAlertOpen(true);
    };
    // ---

    const handleRefreshComponentData = (data) => {
        handleClose();
        if (
            data &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201)
        ) {
            changeApiStatusCodeFunc(data.status);
            setTimeout(() => {
                props.handleRefreshComponent();
            }, 800);
        } else {
            changeApiStatusCodeFunc(data.status);
        }
    }

    const [origin, setOrigin] = useState<any>({
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "left",
        },
    });

    const divRef = React.useRef();

    return (
        <>
            {tableViewList && tableViewList.length ? (
                <div ref={divRef}>
                    <CustomBox className={classes.viewSelectorWrapper}>
                        <CustomBox
                            className={clsx(classes.viewSelectorDropdown)}
                            aria-describedby={id}
                            onClick={handleClick}
                        >
                            <div className={classes.headerTitleWrapper}>
                                <CustomTypography
                                    component="h3"
                                    variant="h3"
                                    className={classes.headerTitle}
                                >
                                    {selectedTableView ? (
                                        <Trans
                                            i18nKey={`TABLE_TITLE_${selectedTableView.tableName.replace(
                                                /\s/g,
                                                ""
                                            )}`}
                                        >
                                            {selectedTableView.tableName}
                                        </Trans>
                                    ) : null}
                                </CustomTypography>
                                <span className={clsx(classes.subTitle)}>
                                    ({moment(startDate).format("DD MMM")} -{" "}
                                    {`${moment(endDate).format("DD MMM")}, ${moment(endDate).format("YYYY")}`})
                                </span>
                            </div>
                            {isViewChangeEnabled ? <CustomExpandMoreIcon /> : null}
                        </CustomBox>
                        {
                            isExportEnabled ? <CustomIconButton style={{ margin: '10px', alignItems: 'flex-start' }} onClick={handleExportClick}>
                                {/* <CustomLaunchOutlinedIcon /> */}
                                <img src={exportIcon} />
                            </CustomIconButton> : null
                        }
                        {selectedTableView && isViewActionEnabled ? (
                            <PraisoTableTitleAction viewId={selectedTableView.id} //tcId={tcId} 
                                tcCode={tcCode}
                                handleRefreshComponent={handleRefreshComponentData} view={selectedTableView} />
                        ) : null}
                    </CustomBox>

                    {/* <CustomBox className={clsx(classes.viewSelectorWrapper)}>
                        <CustomBox className={clsx(classes.action)}></CustomBox>
                    </CustomBox> */}
                    {isViewChangeEnabled ? (
                        <CustomPopover
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={origin.anchorOrigin as Number}
                            transformOrigin={origin.transformOrigin as Number}
                            className={classes.tableViewListPopover}
                        >
                            <CustomList dense={true} className={classes.tableViewList}>
                                {tableViewList && tableViewList.length
                                    ? tableViewList.map((view, index) => (
                                        <div key={index}>
                                            <CustomListItem
                                                key={`${view.tableName.replace(/\s/g, "")}_${view.id}`}
                                                className={clsx(
                                                    classes.tableViewListItem,
                                                    selectedTableView.id === view.id
                                                        ? classes.isSelected
                                                        : null
                                                )}
                                            >
                                                <div
                                                    className={classes.tableViewListItemInner}
                                                    onClick={
                                                        selectedTableView.id !== view.id
                                                            ? () => changeTableView(view.id)
                                                            : null
                                                    }
                                                >
                                                    {view.isDefault && !view.isSystemDefault ? (
                                                        <span className={classes.customBadge}>
                                                            {t("DEFAULT")}
                                                        </span>
                                                    ) : null}
                                                    {view.isDefault && view.isSystemDefault ? (
                                                        <span className={classes.customBadge}>
                                                            {t("DEFAULT")}
                                                        </span>
                                                    ) : null}
                                                    {view.isSystemDefault && !view.isDefault ? (
                                                        <span className={classes.customDefaultBadge}>
                                                            {t("PRAISO_DEFAULT_VIEW")}
                                                        </span>
                                                    ) : null}
                                                    <CustomListItemText
                                                        className={classes.tableViewListItemText}
                                                        primary={
                                                            <Trans
                                                                i18nKey={`TABLE_TITLE_${view.tableName.replace(
                                                                    /\s/g,
                                                                    ""
                                                                )}`}
                                                            >
                                                                {view.tableName}
                                                            </Trans>
                                                        }
                                                    />
                                                </div>
                                                {isViewActionEnabled ? (
                                                    <PraisoTableTitleAction viewId={view.id} //tcId={tcId} 
                                                        tcCode={tcCode}
                                                        handleRefreshComponent={handleRefreshComponentData}
                                                        view={view} />
                                                ) : null}
                                            </CustomListItem>
                                            <CustomDivider />
                                        </div>
                                    ))
                                    : null}
                                <CustomListItem className={classes.tableViewListItem} onClick={() => handleCustomView()}>

                                    <div className={classes.tableViewListItemInner}><CustomListItemText
                                        className={classes.tableViewListItemText}
                                        primary={t("CREATE_NEW_VIEW")}
                                    ></CustomListItemText></div>
                                    <CustomIconButton className={classes.createIcon}>
                                        <img src={createIcon} />
                                    </CustomIconButton>
                                </CustomListItem>
                            </CustomList>
                        </CustomPopover>
                    ) : null}
                </div>
            ) : null}
            <ErrorAlert
                code={statusValue}
                message={alertMessage}
                description={alertDescription}
                isOpen={isAlertOpen}
                alertType={alertType}
                isClose={(isClose) => setIsAlertOpen(!isClose)}
            />
        </>
    );
}
